<div #outsideModal class="modal">
  <div #modalBody class="modal-content">
    <div class="modal-header">Demande d'autorisation</div>
    <div class="modal-body" *ngIf="formGroupCps && formGroupCpe">
      <ng-container *ngIf="connectionType === connectionTypeCompare.cps || connectionType === connectionTypeCompare.cpf">
        <div class="libelle">
          Confirmez-vous que M/Mme {{ patientName }} (ou son représentant légal) vous autorise à accéder à son DMP ?
        </div>
        <form>
          <div class="radio-wrapper">
            <input type="radio" id="authTypeExplicite" name="autorization-type" [formControl]="formGroupCps.get('autorization')" value="explicite" (click)="autorizationClick($event)">
            <label class="radio-label" for="authTypeExplicite">
              <span class="label-wording">Le patient (ou son représentant légal), préalablement informé, consent au fait que j’accède à son DMP</span>
            </label>
          </div>

          <div class="radio-wrapper">
            <input type="radio" id="authTypeBrisDeGlace" name="autorization-type" [formControl]="formGroupCps.get('autorization')" value="bris-de-glace" (click)="autorizationClick($event)">
            <label class="radio-label" for="authTypeBrisDeGlace">
              <span class="label-wording">J’accède en urgence au DMP. Le patient est hors d’état d’exprimer sa volonté,<br>et il y a un risque immédiat pour sa santé (accès bris de glace)</span>
            </label>
          </div>

          <frg-form-input
            *ngIf="formGroupCps.get('autorization').value === 'bris-de-glace'"
            id="brisDeGlaceReason"
            label="Motif de l’accès en mode bris de glace"
            type="textarea"
            required="true"
            [formGroup]="formGroupCps"
            [control]="formGroupCps.get('brisDeGlaceReason')"
          ></frg-form-input>

          <frg-form-input
            id="alimentation"
            label="Le patient (ou son représentant légal), préalablement informé, n’a pas exprimé d’opposition pour l’alimentation de son DMP"
            type="checkbox"
            isCheckLabelAlign="true"
            [formGroup]="formGroupCps"
            [control]="formGroupCps.get('alimentation')"
          ></frg-form-input>
          <!-- <div class="radio-wrapper" (click)="formGroupCps.get('alimentation').setValue(!formGroupCps.get('alimentation').value)">
            <input type="checkbox" name="alimentation" [formControl]="formGroupCps.get('alimentation')" [value]="true">
            <label class="checkbox-label">
              <span class="label-wording">Le patient (ou son représentant légal), préalablement informé, n’a pas exprimé d’opposition pour l’alimentation de son DMP</span>
            </label>
          </div> -->
        </form>
      </ng-container>

      <ng-container *ngIf="connectionType === connectionTypeCompare.cpe">
        <div class="libelle">
          Confirmez-vous que M/Mme {{ patientName }} (ou son représentant légal) autorise votre structure de soins à accéder à son DMP ?
        </div>

        <frg-form-input
          id="alimentation"
          label="Le patient (ou son représentant légal), préalablement informé, n’a pas exprimé d’opposition pour l’alimentation de son DMP"
          type="checkbox"
          isCheckLabelAlign="true"
          [formGroup]="formGroupCpe"
          [control]="formGroupCpe.get('alimentation')"
        ></frg-form-input>
      </ng-container>

      <div class="button-container">
        <frg-button [backgroundColor]="'var(--darkest-primary)'" (activated)="closeModal()">Annuler</frg-button>
        <frg-button *ngIf="connectionType === connectionTypeCompare.cps || connectionType === connectionTypeCompare.cpf" [disabled]="!formGroupCps.valid" (activated)="confirmAutorization()">Valider</frg-button>
        <frg-button *ngIf="connectionType === connectionTypeCompare.cpe" (activated)="confirmAutorization()">Valider</frg-button>
      </div>
    </div>
  </div>
</div>
<div class="modal-background"></div>